import { useContext, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import * as H from 'history'
import { ContentBody, ContentHeader } from 'components/shared/content'
import { CheckboxTableRow, ExTable, TableBody, TableCell, TableHead, TableWrapper, useMultipleCheckForm } from 'components/shared/widget'
import { useConfirmRequestFormErrorApi, useDownloadCsvRequestFormErrorsApi, useFetchRequestFormErrorsApi } from 'api/request_form_error'
import { RequestFormError, RequestFormErrorSearchForm } from 'entities/request_form_error'
import { Pagination } from 'components/shared/pagination'
import { useEffectSkipFirst, useForm, useQuery } from 'utils/hooks'
import { SearchConditionView } from 'components/shared/search_drawer'
import { GlobalStateContext } from 'contexts/global_state_context'
import { requestFormErrorColumnInfoList, RequestFormErrorTableData } from './request_form_error_table'
import { TableHeads, useDisplaySetting } from 'components/shared/display_setting'
import qs from 'qs'
import { useState } from 'react'
import { EditRequestFormErrorForm, NewRequestFormErrorForm } from './request_form_error_form'
import { Flex } from 'components/shared/flex'
import { Button } from 'react-bootstrap'
import { RequestFormErrorViewModel } from 'view_models/request_form_error_view_model'

type Props = {
    history: H.History
}

const RequestFormErrorsPage = (props: Props) => {
    const globalState = useContext(GlobalStateContext)
    const params = useQuery<RequestFormErrorSearchForm>()
    const searchForm = useForm<RequestFormErrorSearchForm>({ ordering: '-request_form_error_request_date', ...params })
    const api = useFetchRequestFormErrorsApi(searchForm)
    const downloadCsvApi = useDownloadCsvRequestFormErrorsApi(searchForm)
    const multipleCheckForm = useMultipleCheckForm<RequestFormError>()
    const requestFormErrorDisplaySetting = useDisplaySetting(requestFormErrorColumnInfoList(searchForm), 'RequestFormError')
    const [selectedRequestFormError, setSelectedRequestFormError] = useState<RequestFormError>({})
    const [showEdit, setShowEdit] = useState<boolean>(false)
    const confirmApi = useConfirmRequestFormErrorApi()

    useEffect(() => {
        api.execute()
    }, [])

    const handleClickRemoveFilter = (key: keyof RequestFormErrorSearchForm): void => {
        searchForm.update((f) => {
            delete f[key]
        })
    }

    useEffect(() => {
        const queryParams = qs.stringify({ ...searchForm.object, page: api.pageSet.page, perPage: api.pageSet.perPage })
        if (props.history.location.search.replace('?', '') !== queryParams) {
            props.history.replace(`request_form_errors?${queryParams}`)
        }
    }, [searchForm.object])

    const handleClickEdit = (requestFormError: RequestFormError) => {
        setSelectedRequestFormError(requestFormError)
        setShowEdit(true)
    }

    useEffectSkipFirst(() => {
        globalState.setLoading(downloadCsvApi.loading)
    }, [downloadCsvApi.loading])

    useEffectSkipFirst(() => {
        globalState.setLoading(confirmApi.loading)
        if (confirmApi.isSuccess()) {
            api.execute()
        }
    }, [confirmApi.loading])

    return (
        <>
            <EditRequestFormErrorForm
                requestFormError={selectedRequestFormError}
                show={showEdit}
                onClose={() => setShowEdit(false)}
                onComplete={() => {
                    api.execute()
                    setShowEdit(false)
                }}
            />

            <ContentHeader
                headerTitle="検査依頼書入力不備"
                left={
                    <>
                        {/* <CopyTableButton /> */}

                        <NewRequestFormErrorForm
                            onComplete={() => {
                                api.execute()
                            }}
                        />
                        <SearchConditionView searchForm={searchForm} onClickRemoveButton={handleClickRemoveFilter} />
                    </>
                }
                right={<>{/* <DisplaySettingModal displaySettings={displaySettings} /> */}</>}
            />
            <Flex style={{ marginTop: 5 }} alignItems="center" justifyContent="space-between">
                <div></div>
                <Flex alignItems="center">
                    <Pagination pageSet={api.pageSet} response={api.response}></Pagination>
                    <div style={{ minWidth: 140, textAlign: 'right' }}>総件数： {api.response.count.toLocaleString()}件</div>
                </Flex>
            </Flex>
            <ContentBody>
                <TableWrapper contentHeaderCount={2}>
                    <ExTable className="sticky-table">
                        <TableHead>
                            <CheckboxTableRow head allCheck allItems={api.response.results} multipleCheckForm={multipleCheckForm} showEdit>
                                <TableCell th width={130} />
                                <TableHeads displaySetting={requestFormErrorDisplaySetting} />
                            </CheckboxTableRow>
                        </TableHead>
                        <TableBody loading={api.loading} columnLength={requestFormErrorDisplaySetting.getColumnLength() + 3}>
                            {api.response.results.map((requestFormError: RequestFormError) => {
                                return (
                                    <CheckboxTableRow
                                        key={`requestFormError-${requestFormError.id}`}
                                        item={requestFormError}
                                        multipleCheckForm={multipleCheckForm}
                                        onClickEdit={() => handleClickEdit(requestFormError)}
                                    >
                                        <TableCell align="center">
                                            {!requestFormError.correspondingUser?.fullName ? (
                                                <Button
                                                    variant="success"
                                                    size="sm"
                                                    onClick={(e) => {
                                                        e.stopPropagation()
                                                        setSelectedRequestFormError(requestFormError)
                                                        setShowEdit(true)
                                                    }}
                                                >
                                                    変更内容入力
                                                </Button>
                                            ) : (
                                                !requestFormError.confirmationUser?.fullName && (
                                                    <Button
                                                        variant="warning"
                                                        size="sm"
                                                        onClick={(e) => {
                                                            e.stopPropagation()
                                                            const vm = new RequestFormErrorViewModel(requestFormError)
                                                            globalState.showConfirm(
                                                                <>
                                                                    <div>以下の内容に変更・修正されました。検査依頼書に変更内容を記入してください</div>
                                                                    <div>変更内容を記入したらOKをクリックしてください</div>
                                                                    <div>※ この検査依頼書の検品作業を忘れないように</div>
                                                                    <div style={{ padding: 10 }}>
                                                                        {
                                                                            <div>
                                                                                {Object.keys(vm.items()).map((key, index) => {
                                                                                    const value = vm.items()[key]
                                                                                    return (
                                                                                        <div key={'error-item-' + index}>
                                                                                            {key}: {value ? value : '確認中'}
                                                                                        </div>
                                                                                    )
                                                                                })}
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                </>,
                                                                () => {
                                                                    confirmApi.execute(requestFormError.id!)
                                                                }
                                                            )
                                                        }}
                                                    >
                                                        変更内容確認
                                                    </Button>
                                                )
                                            )}
                                        </TableCell>
                                        <RequestFormErrorTableData requestFormError={requestFormError} displaySetting={requestFormErrorDisplaySetting} />
                                    </CheckboxTableRow>
                                )
                            })}
                        </TableBody>
                    </ExTable>
                    <Pagination pageSet={api.pageSet} response={api.response}></Pagination>
                </TableWrapper>
            </ContentBody>
        </>
    )
}

export default withRouter(RequestFormErrorsPage)
